import areaService from '../services/area.service';

const areas = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        create(_, model) {
            return areaService.create(model);
        },

        //READ
        get(_, params) {
            return areaService.get(params.id, params.urlParameters, params.requestId);
        },
        getlist() {
            return areaService.getlist();
        },
        getUserAreasList() {
            return areaService.getUserAreasList();
        },
        //UPDATE
        update(_, model) {
            return areaService.update(model);
        },

        //DELETE
        delete(_, id) {
            return areaService.delete(id);
        },
    },
    getters: {},
    mutations: {},
};

export default areas;
